// extracted by mini-css-extract-plugin
export default {"component":"Page__component___Hrwnd"};